import dayjs from 'dayjs';
import { DateFilter } from '../../search-results-toolbar/search-results-toolbar';

export const convertToISOString = (
  date: DateFilter | string,
  manipulation?: { startOfDay?: boolean; endOfDay?: boolean }
) => {
  if (date) {
    const dayJsDate = manipulateDate(date, manipulation);

    return dayJsDate.toISOString();
  }
};

export const convertToDate = (
  date: DateFilter | string,
  manipulation?: { startOfDay?: boolean; endOfDay?: boolean }
) => {
  if (date) {
    const dayJsDate = manipulateDate(date, manipulation);

    return dayJsDate.toDate();
  }
};

const manipulateDate = (
  date: DateFilter | string,
  manipulation?: { startOfDay?: boolean; endOfDay?: boolean }
) => {
  let dayJsDate = dayjs.utc(date);

  // Apply optional manipulation
  if (manipulation?.startOfDay) {
    dayJsDate = dayJsDate.startOf('day');
  }
  if (manipulation?.endOfDay) {
    dayJsDate = dayJsDate.endOf('day');
  }

  return dayJsDate;
};
